import React from "react";
import { Button } from "react-bootstrap";
import "./backbutton.scss";

function BackArrow({ width = "27", height = "29" }) {
  return (
    <svg width={width} height={height} viewBox="0 0 27 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.847 11.1486H11.9421L17.3131 6.03318C17.7775 5.5911 18.0097 5.06139 18.0097 4.44446C18.0097 3.82775 17.7777 3.29803 17.3131 2.85575L15.9383 1.56382C15.4741 1.12175 14.924 0.900391 14.2886 0.900391C13.6408 0.900391 13.0846 1.12153 12.6205 1.56382L0.686676 12.912C0.234426 13.3658 0.00830078 13.8955 0.00830078 14.5007C0.00830078 15.1176 0.234426 15.6413 0.686676 16.0718L12.6205 27.4549C13.097 27.8856 13.653 28.1012 14.2886 28.1012C14.9362 28.1012 15.4861 27.8856 15.9383 27.4549L17.3131 26.1283C17.7775 25.7093 18.0097 25.1856 18.0097 24.5571C18.0097 23.9284 17.7777 23.4045 17.3131 22.9855L11.9421 17.8527H24.847C25.4826 17.8527 25.9987 17.6346 26.3961 17.1981C26.7932 16.7616 26.9917 16.2351 26.9917 15.6182V13.3834C26.9919 12.7665 26.7932 12.2397 26.3961 11.8032C25.9987 11.3667 25.4826 11.1486 24.847 11.1486Z"
        fill="white"
      />
    </svg>
  );
}

interface IBackButtonProps {
  onClick: () => void;
}

function BackButton({ onClick }: IBackButtonProps) {
  function goBack() {
    onClick();
  }
  return (
    <Button variant="back" onClick={goBack} aria-label="Go back">
      <BackArrow />
      <span className="sr-only">Go back</span>
    </Button>
  );
}

export default BackButton;
